import { render } from "./Chek_box.vue?vue&type=template&id=11ff593a&scoped=true"
import script from "./Chek_box.vue?vue&type=script&lang=js"
export * from "./Chek_box.vue?vue&type=script&lang=js"

import "./Chek_box.vue?vue&type=style&index=0&id=11ff593a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ff593a"]])

export default __exports__